/** Runtime simulator management. Admin-only server-side; every spawn is audited. */

import { api, type ApiResult } from '@/api/client';

export interface SimInfo {
  droneId: string;
  callsign: string;
  state: string;
}

export interface SimList {
  simulators: SimInfo[];
  max: number;
  types: string[];
}

export function listSimulators(): Promise<ApiResult<SimList>> {
  return api.get<SimList>('/sim', { logged: false });
}

export function spawnSimulators(options: {
  vehicleType: string;
  lat: number;
  lon: number;
  count?: number;
}): Promise<ApiResult<{ added: string[]; vehicleType: string }>> {
  return api.post('/sim', options, { label: `SIM SPAWN ${options.vehicleType}` });
}

export function removeSimulator(droneId: string): Promise<ApiResult<{ removed: string }>> {
  return api.delete(`/sim/${encodeURIComponent(droneId)}`, { label: `SIM REMOVE ${droneId}` });
}

/**
 * Move a simulator on the map.
 *
 * Simulators only. Dragging a real aircraft's icon would be a goto — flying it
 * somewhere — and that belongs behind the explicit GOTO affordance with its
 * confirmation, not a stray mouse gesture.
 */
export function repositionSimulator(
  droneId: string,
  lat: number,
  lon: number,
): Promise<ApiResult<{ droneId: string; lat: number; lon: number }>> {
  return api.post<{ droneId: string; lat: number; lon: number }>(
    `/sim/${encodeURIComponent(droneId)}/position`,
    { lat, lon },
    { logged: false },
  );
}
